import { router } from '@inertiajs/vue3'
import axios from 'axios'
import { route } from 'ziggy-js'

const Http = axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

// Handle 401 Unauthorized responses globally
// This handles session expiration by redirecting to login
Http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Session expired - redirect to login
      router.visit(route('login'))
      // Return a rejected promise that won't trigger unhandled rejection
      return new Promise(() => {})
    }
    return Promise.reject(error)
  }
)

export default Http
